/**
 * @summary Cria o state de estrafificações.
 * @returns State de estratificações.
 */
const EmptyStratificationStatefactory = function()
{
	return {
		mode:  true,
		rules: [],
	};
};

export default { EmptyStratificationStatefactory };